var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c(_vm.viewComponent,{key:_vm.$currentView.id,tag:"component",attrs:{"fields":_vm.fields,"data":_vm.data,"can":_vm.can,"filter":_vm.filter,"view":_vm.view}},[(_vm.hasMore)?_c('core-content-scrollload',{on:{"scrolled":function($event){return _vm.$emit('scroll')}}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }